import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../Box/Box';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import PlusIcon from '../../icons/PlusIcon';

const AffiliateDiscount = ({ discounts, onApplyDiscount }) => {
  const { t } = useTranslation();
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenBox = () => {
    setIsOpen(!isOpen);
  };

  const onHandleClick = (discount) => {
    setSelectedDiscount(discount);
    if (onApplyDiscount) onApplyDiscount(discount);
  };

  return (
    <>
      <div
        className='section-title d-flex align-items-center'
        onClick={handleOpenBox}
        style={{ gap: '5px', cursor: 'pointer' }}
      >
        {t('affiliateDiscount')} <PlusIcon size={16} color='var(--color-primary)' />
      </div>
      <div className={['box-wrapper', isOpen ? 'show' : ''].join(' ')}>
        <Box>
          <div className='text-secondary font-tiny fw-400 mb-3'>
            {t('affiliateDiscountDescription')}
          </div>
          <Swiper spaceBetween={10} slidesPerView={4}>
            {discounts.length > 0 &&
              discounts.map((discount, index) => (
                <SwiperSlide key={index}>
                  <button
                    className={`btn btn-secondary btn-pill btn-outline btn-small w-100 ${
                      selectedDiscount === discount.value ? 'btn-success selected' : ''
                    }`}
                    onClick={() => onHandleClick(discount.value)}
                  >
                    {discount.value}%
                  </button>
                </SwiperSlide>
              ))}
          </Swiper>
        </Box>
      </div>
    </>
  );
};

export default AffiliateDiscount;
